export default {
  computed: {
    tealiumPayload() {
      const annuncioVtour =
        (this.property.type === 'v2' && this.property.features.virtual_tour) ||
        this.property.virtual_tour
          ? '1'
          : '0'
      const annuncioVetrina =
        (this.property.type === 'v2' && this.property.is_showcase) ||
        this.property.showcase
          ? '1'
          : '0'
      const annuncioNetwork =
        (this.property.agent &&
          this.property.agent.type === 'network_agenti') ||
        (this.property.partner &&
          this.property.partner.type === 'network_agenti')
          ? '1'
          : '0'

      return {
        id: this.property.id,
        annuncio_categoria: this.$tealium.propertyCategory(this.property),
        annuncio_vtour: annuncioVtour,
        annuncio_vetrina: annuncioVetrina ? '1' : '0',
        annuncio_certificato: this.property.certificate ? '1' : '0',
        annuncio_network: annuncioNetwork,
        annuncio_diminuzione_prezzo: 'NO',
        ...(this.$config.uclamActive
          ? // eslint-disable-next-line eqeqeq
            { annuncio_unicredit: this.property.source_id == 4 ? '1' : '0' }
          : {}),
      }
    },
  },
}
